module.exports = __webpack_public_path__ + "static/media/portfolio-03.b1ee6056.jpg";